<script>
    import TeamPickerForm from "../Teams/Form/Picker";
    import ClubSelect from './ClubSelect';
    import HtmlCharity from "./HtmlCharity.vue";
    import ValueStorage from '../Utility/InlineTemplates/ValueStorage.vue';
    import GroupSelectInput from '../Utility/Forms/InputFields/GroupSelect.vue';

    export default {
        components: {
            TeamPickerForm,
            ClubSelect,
            HtmlCharity,
            ValueStorage,
            GroupSelectInput,
        },
        props: {
            participant: {
                type: Object,
                required: true
            },
            searchTransferableRegistrationCategories: {
                type: Boolean,
                required: false,
                default: false,
            },
            onlyTeamTicket: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                team_id: null,
                field_values: {},
                registration_categories: {},
                selectedRegistrationCategoryId: this.participant.registration_category_id || '',
                optedOutAdditionsData: [],
                isLoadingOptedOutAdditions: false,
            }
        },
        created() {
            var self = this;
            this.team_id = this.participant.team_id;

            if (Object.hasOwnProperty.call(this.participant, 'additional_participant_values') && this.participant.additional_participant_values.length) {
                this.participant.additional_participant_values.forEach(function (item) {
                    Vue.set(self.field_values, item.addition_id, item.addition_multiple_option_id);
                });
            }

            if (this.searchTransferableRegistrationCategories) {
                this.getMovableRegistrationCategoriesList();
            }

            if (this.selectedRegistrationCategoryId) {
                this.fetchOptedOutAdditions();
            }
        },
        watch: {
            selectedRegistrationCategoryId(newValue) {
                if (newValue) {
                    this.fetchOptedOutAdditions();
                } else {
                    this.optedOutAdditionsData = [];
                }
            }
        },
        computed: {
            optedOutAdditionIdsForSelectedCategory() {
                return this.optedOutAdditionsData;
            },
            isLoadingAdditions() {
                return this.isLoadingOptedOutAdditions;
            }
        },
        methods: {
            isAdditionOptedOut(additionId) {
                return this.optedOutAdditionIdsForSelectedCategory.includes(additionId);
            },
            hasVisibleAdditions(allAdditionIds) {
                // If no registration category is selected, show all additions
                if (!this.selectedRegistrationCategoryId) {
                    return true;
                }
                // Check if at least one addition is NOT opted out
                return allAdditionIds.some(additionId => !this.isAdditionOptedOut(additionId));
            },
            saveForm() {
                this.$refs.cakeForm.submit();
            },

            async getMovableRegistrationCategoriesList() {
                let url = `/api/v0/registration_categories/${this.participant.occasion_id}/movable_list?rc_id=${this.participant.registration_category_id}`;

                if (this.onlyTeamTicket) {
                    url += `&team_ticket=true`;
                }

                try {
                    const response = await this.$root.makeApiRequest(async (jwtToken) => {
                        return await axios.get(url, {
                            headers: {
                                'Authorization': jwtToken,
                                'Accept': 'application/json'
                            }
                        });
                    });

                    if (response.data && response.data.status === 'success' && response.data.data) {
                        this.registration_categories = response.data.data;
                    }
                } catch (error) {
                    console.error('Failed to fetch movable registration categories:', error);
                }
            },

            async fetchOptedOutAdditions() {
                if (!this.selectedRegistrationCategoryId) {
                    return;
                }

                this.isLoadingOptedOutAdditions = true;
                const url = `/api/v0/opt_out_occasion_form_fields/opted_out_additions/${this.selectedRegistrationCategoryId}`;

                try {
                    const response = await this.$root.makeApiRequest(async (jwtToken) => {
                        return await axios.get(url, {
                            headers: {
                                'Authorization': jwtToken,
                                'Accept': 'application/json'
                            }
                        });
                    });

                    if (response.data && response.data.status === 'success' && response.data.data) {
                        this.optedOutAdditionsData = response.data.data;
                    }
                } catch (error) {
                    console.error('Failed to fetch opted out additions:', error);
                    this.optedOutAdditionsData = [];
                } finally {
                    this.isLoadingOptedOutAdditions = false;
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/ParticipantEditForm.vue